import { MutationTree } from 'vuex'
import { TriggeredActionState } from '@/store/triggeredActions/index'
import { PageResult } from '@/api/types'
import { TriggeredAction } from '@/api/model/triggered-action'

export const mutations: MutationTree<TriggeredActionState> = {
    fetchData(state: TriggeredActionState): void {
        state.loading = true
        state.totalItems = null
        state.error = null
    },

    fetchDataSuccess(state: TriggeredActionState, result: PageResult<TriggeredAction>): void {
        state.loading = false
        state.error = null
        state.triggeredActions = result.collection
        state.totalItems = result.totalItems
        state.totalPages = result.totalPages
    },

    fetchDataFailure(state: TriggeredActionState, error: string): void {
        state.loading = false
        state.error = error
    },

    setPage(state: TriggeredActionState, payload: {page: number }): void {
        state.page = payload.page
    },

    applyOrder(state: TriggeredActionState, payload: { field: string, direction: string}): void {
        state.orderField = payload.field
        state.orderDirection = payload.direction
    },

    applyActiveFilter(state: TriggeredActionState, payload: {activeFilter: number[] }): void {
        state.activeFilter = payload.activeFilter
    },

    applyCompanyFilter(state: TriggeredActionState, payload: {query: string }): void {
        state.companyFilter = payload.query
    },

    applyNameFilter(state: TriggeredActionState, payload: { query: string}): void {
        state.nameFilter = payload.query
    },

    resetFilters(state: TriggeredActionState): void {
        state.activeFilter = null
        state.nameFilter = null
    },
}
